<template>
  <div id="root">
    <div class="container">
      <div
        class="row"
        v-show="allFields"
        :class="{
          validationError: validationErrors.nameError,
          noError: !validationErrors.nameError
        }"
      >
        <div class="col-md-4">
          Group Name
        </div>
        <div class="col-md-8">
          <el-input
            type="text"
            id="name"
            placeholder="Name"
            v-model="name"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.nameError"
            :class="{
              validationErrorText: validationErrors.nameError
            }"
          >
            {{ validationErrors.nameError }}
          </p>
        </div>
      </div>
      <div
        class="row"
        v-show="editLeader || allFields"
        :class="{
          validationError: validationErrors.leaderError,
          noError: !validationErrors.leaderError
        }"
      >
        <div class="col-md-4">
          Leader
          <i
            v-show="editLeader"
            class="el-icon-delete icon-btn float-right"
            @click="validateDeleteLeader(1)"
          />
        </div>
        <div
          class="col-md-8"
          v-show="editLeader"
        >
          <el-autocomplete
            v-model="leaders.searchQuery1"
            :fetch-suggestions="queryEligibleLeaders"
            value-key="name"
            placeholder="Search for leader"
            @select="handleSelectFirstLeader"
            id="autocompleteLeader1"
            style="width: 100%;"
            @blur="checkEmpty()"
          />
        </div>
        <div
          class="col-md-8"
          v-show="disableLeader"
        >
          <el-autocomplete
            placeholder="You"
            style="width: 100%;"
            disabled
          />
        </div>
      </div>
      <div
        class="row"
        v-show="(editLeader || allFields) && !leaders.showSecond"
        :class="{
          validationError: validationErrors.leaderError,
          noError: !validationErrors.leaderError
        }"
      >
        <div class="col-md-4" />
        <div class="col-md-8 add-shadowbox">
          <div
            @mouseover="leaders.hoverClass = true"
            @mouseleave="leaders.hoverClass = false"
            @click="addSecondLeader()"
          >
            Add another leader
            <i
              @click="addSecondLeader()"
              :class="{
                'el-icon-plus': true,
                'icon-btn': true,
                'hoverClass': leaders.hoverClass
              }"
            />
          </div>
        </div>
      </div>
      <div
        class="row"
        v-show="(editLeader || allFields) && leaders.showSecond"
        :class="{
          validationError: validationErrors.leaderError,
          noError: !validationErrors.leaderError
        }"
      >
        <div class="col-md-4">
          <i
            class="el-icon-delete icon-btn float-right"
            @click="validateDeleteLeader(2)"
          />
        </div>
        <div class="col-md-8">
          <el-autocomplete
            v-model="leaders.searchQuery2"
            :fetch-suggestions="queryEligibleLeaders"
            value-key="name"
            placeholder="Search for leader"
            @select="handleSelectSecondLeader"
            id="autocompleteLeader2"
            style="width: 100%;"
            @blur="checkEmpty()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.leaderError"
            :class="{
              validationErrorText: validationErrors.leaderError
            }"
          >
            {{ validationErrors.leaderError }}
          </p>
        </div>
      </div>
      <div
        class="row"
        v-show="allFields"
        :class="{
          validationError: validationErrors.dayError,
          noError: !validationErrors.dayError
        }"
      >
        <div class="col-md-4">
          Day
        </div>
        <div class="col-md-8">
          <el-select
            id="day"
            v-model="dayOfWeek"
            placeholder="Select Sun-Sat"
            clearable
            class="select-default light-gray"
            style="width: 100%;"
          >
            <el-option
              v-for="day in dayOptions"
              :key="day.value"
              :label="day.label"
              :value="day.value"
            />
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.dayError"
            :class="{
              validationErrorText: validationErrors.dayError
            }"
          >
            {{ validationErrors.dayError }}
          </p>
        </div>
      </div>
      <div
        class="row"
        v-show="allFields"
        :class="{
          validationError: validationErrors.timeError,
          noError: !validationErrors.timeError
        }"
      >
        <div class="col-md-4">
          Time
        </div>
        <div class="col-md-8" style="display: flex;">
          <el-select
            id="hour"
            v-model="meetingHour"
            placeholder="H"
            style="width: 30%; display: inline-block"
            clearable
            class="select-default light-gray"
          >
            <el-option
              v-for="hour in hourOptions"
              :key="hour.value"
              :label="hour.value"
              :value="hour.value"
            />
          </el-select>
          <el-select
            id="minute"
            v-model="meetingMinute"
            placeholder="M"
            style="width: 30%; display: inline-block"
            clearable
            class="select-default light-gray"
          >
            <el-option
              v-for="minute in minuteOptions"
              :key="minute.value"
              :label="minute.label"
              :value="minute.value"
            />
          </el-select>
          <el-select
            id="daytime"
            v-model="meetingDayTime"
            placeholder="am/pm"
            style="width: 30%; display: inline-block"
            clearable
            class="select-default light-gray"
          >
            <el-option
              v-for="time in dayTimeOptions"
              :key="time.value"
              :label="time.label"
              :value="time.value"
            />
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.timeError"
            :class="{
              validationErrorText: validationErrors.timeError
            }"
          >
            {{ validationErrors.timeError }}
          </p>
        </div>
      </div>
      <div
        class="row"
        v-show="allFields"
        :class="{
          validationError: validationErrors.recurringTypeError,
          noError: !validationErrors.recurringTypeError
        }"
        v-if="isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])"
      >
        <div class="col-md-4">
          Recurs
        </div>
        <div class="col-md-8">
          <el-select
            id="recurringType"
            v-model="recurringType"
            placeholder="Select type"
            clearable
            class="select-default light-gray"
            style="width: 100%;"
          >
            <el-option
              v-for="type in recurringTypeOptions"
              :key="type.value"
              :label="type.label"
              :value="type.label"
            />
          </el-select>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.recurringTypeError"
            :class="{
              validationErrorText: validationErrors.recurringTypeError
            }"
          >
            {{ validationErrors.recurringTypeError }}
          </p>
        </div>
      </div>
      <div
        class="row"
        v-show="allFields"
        :class="{
          validationError: validationErrors.locationError,
          noError: !validationErrors.locationError
        }"
      >
        <div class="col-md-4">
          Location
        </div>
        <div class="col-md-8">
          <el-input
            type="text"
            id="meeting_location"
            placeholder="Location"
            v-model="meetingLocation"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.locationError"
            :class="{
              validationErrorText: validationErrors.locationError
            }"
          >
            {{ validationErrors.locationError }}
          </p>
        </div>
      </div>
      <!-- start date -->
      <div
        class="row"
        :class="{
          validationError: validationErrors.startDateError,
          noError: !validationErrors.startDateError
        }"
        v-show="!disableStartDate"
      >
        <div class="col-md-4">
          Start date
        </div>
        <div class="col-md-8">
          <datepicker
            class="datepicker"
            placeholder="Select Date"
            v-model="startDate"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <p
            v-show="validationErrors.startDateError"
            :class="{
              validationErrorText: validationErrors.startDateError
            }"
          >
            {{ validationErrors.startDateError }}
          </p>
        </div>
      </div>

      <div style="margin-top: 20px;" v-show="!disableParticipants">
        <h2 class="card-title center">
          Participants
        </h2>
        <el-autocomplete
          v-model="queryBSPs"
          :fetch-suggestions="queryEligibleParticipants"
          value-key="name"
          @select="handleSelectParticipant"
          id="searchAutocomplete-newstudy"
          style="width: 100%;"
        />
        <table class="table table-hover" v-show="selectedParticipants">
          <tbody>
            <tr
              v-for="participant in selectedParticipants"
              :key="participant.id"
            >
              <td style="width: 100%;">
                {{ participant.name }}
                <el-button
                  @click="handleRemoveFromSelected(participant)"
                  class="small"
                >
                  <i class="el-icon-close" />
                </el-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <modal
        :show="leaders.validateDelete"
        :show-header="false"
        header-classes="justify-content-center center"
      >
        <p>Are you sure you want to remove this leader?</p>
        <div>
          <p-button style="float: right" @click="leaders.validateDelete = false">
            Cancel
          </p-button>
          <p-button
            style="float: right"
            class="custom-modal-type"
            @click="removeLeader(leaders.delete)"
          >
            Yes
          </p-button>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import {
    mapState
} from 'vuex';
import modal from '../UIComponents/Modal';

function sanitizeHour(time) {
    if (!time) {
        return time;
    }
    const hour = parseInt(time.substring(0, 2), 10);
    switch (true) {
    case hour === 0: return 12;
    case hour === 12: return 12;
    case hour > 12: return hour - 12;
    default: return hour;
    }
}

function sanitizeMinute(time) {
    return time ? time.substring(3, 5) : time;
}

function sanitizeDayTime(time) {
    if (!time) {
        return time;
    }
    const hour = parseInt(time.substring(0, 2), 10);
    switch (true) {
    case hour === 0: return 1; // 2400 is 00 AM
    case hour >= 12: return 2; // 1200 - 1300 is PM
    default: return 1; // AM
    }
}

function calculateTime(meetingHour, meetingMinute, meetingDayTime) {
    switch (true) {
    // 12:00 AM -> 0:00:00
    case (meetingDayTime === 1 && parseInt(meetingHour, 10) === 12):
        return `00:${meetingMinute}:00`;
    // 8:00 AM -> 08:00:00
    case (meetingDayTime === 1 && parseInt(meetingHour, 10) < 10):
        return `0${parseInt(meetingHour, 10)}:${meetingMinute}:00`;
    // 2:00 PM -> 14:00:00
    case (meetingDayTime === 2 && parseInt(meetingHour, 10) !== 12):
        return `${parseInt(meetingHour, 10) + 12}:${meetingMinute}:00`;
    default:
    // 10:00 AM -> 10:00:00
        return `${meetingHour}:${meetingMinute}:00`;
    }
}

export default {
    name: 'BSForm',
    components: {
        Datepicker,
        modal
    },
    data() {
        return {
            namespace: 'BibleStudies',
            leaders: {
                searchQuery1: '',
                searchQuery2: '',
                selected1: null,
                selected2: null,
                validateDelete: false,
                hoverClass: false,
                showSecond: false,
                delete: null,
            },
            queryBSPs: '',
            unselectedParticipants: this.eligibleParticipants,
            selectedParticipants: [],
            name: '',
            dayOfWeek: '',
            meetingHour: '',
            meetingMinute: '',
            meetingDayTime: '',
            recurringType: '',
            meetingLocation: '',
            startDate: null,
            endDate: null,
            validationErrors: {
                nameError: null,
                leaderError: null,
                dayError: null,
                timeError: null,
                locationError: null,
                startDateError: null,
                inlineAlert: null,
            },
            savingStatus: 'Save',
            dayOptions: [
                { value: 0, label: 'Sunday' },
                { value: 1, label: 'Monday' },
                { value: 2, label: 'Tuesday' },
                { value: 3, label: 'Wednesday' },
                { value: 4, label: 'Thursday' },
                { value: 5, label: 'Friday' },
                { value: 6, label: 'Saturday' },
            ],
            hourOptions: [
                { value: 1 },
                { value: 2 },
                { value: 3 },
                { value: 4 },
                { value: 5 },
                { value: 6 },
                { value: 7 },
                { value: 8 },
                { value: 9 },
                { value: 10 },
                { value: 11 },
                { value: 12 },
            ],
            minuteOptions: [
                { value: 0, label: '00' },
                { value: 15, label: '15' },
                { value: 30, label: '30' },
                { value: 45, label: '45' },
            ],
            dayTimeOptions: [
                { value: 1, label: 'am' },
                { value: 2, label: 'pm' }
            ],
            recurringTypeOptions: [
                { value: 1, label: 'Weekly' },
                { value: 2, label: 'Biweekly' },
                { value: 3, label: 'Monthly' }
            ],
        };
    },
    props: {
        participants: Array,
        bibleStudy: Object,
        disableStartDate: {
            type: Boolean,
            default: false
        },
        disableParticipants: {
            type: Boolean,
            default: false
        },
        allFields: {
            type: Boolean,
            default: false
        },
        editLeader: {
            type: Boolean,
            default: false
        },
        disableLeader: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
            eligibleParticipants: (state) => state.BibleStudies.eligibleParticipants,
            eligibleLeaders: (state) => state.BibleStudies.eligibleLeaders,
        }),
    },
    watch: {
        eligibleParticipants() {
            this.unselectedParticipants = this.eligibleParticipants;
        },
        eligibleLeaders() {
            this.updateBibleStudy();
        },
        bibleStudy() {
            this.updateBibleStudy();
        },
    },
    methods: {
        validateInput() {
            // Name is required
            switch (this.name === '') {
            case true:
                this.validationErrors.nameError = 'Please enter a name.';
                break;
            default:
                this.validationErrors.nameError = null;
            }
            // If it is not create, then at least one leader is required
            switch (this.editLeader && (this.leaders.selected1 === null && this.leaders.selected2 === null)) {
            case true:
                this.validationErrors.leaderError = 'Please select a leader.';
                break;
            default:
                this.validationErrors.leaderError = null;
            }
            switch (this.dayOfWeek === '') {
            case true:
                this.validationErrors.dayError = 'Please select a day.';
                break;
            default:
                this.validationErrors.dayError = null;
            }
            switch (this.meetingHour === '' || this.meetingMinute === '' || this.meetingDayTime === '') {
            case true:
                this.validationErrors.timeError = 'Please select a valid time.';
                break;
            default:
                this.validationErrors.timeError = null;
            }
            switch (this.recurringType === ''
              && this.isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])
            ) {
            case true:
                this.validationErrors.recurringTypeError = 'Please select a recurring type.';
                break;
            default:
                this.validationErrors.recurringTypeError = null;
            }
            switch (this.meetingLocation === '') {
            case true:
                this.validationErrors.locationError = 'Please enter a location.';
                break;
            default:
                this.validationErrors.locationError = null;
            }
            switch (this.startDate == null && !this.disableStartDate) {
            case true:
                this.validationErrors.startDateError = 'Please select a start date.';
                break;
            default:
                this.validationErrors.startDateError = null;
            }
            switch (!this.validationErrors.nameError && !this.validationErrors.leaderError
                    && !this.validationErrors.dayError
                    && !this.validationErrors.timeError && !this.validationErrors.locationError
                    && !this.validationErrors.startDateError && !this.validationErrors.recurringTypeError) {
            case true:
                this.handleSave();
                break;
            default:
                break;
            }
        },
        handleSave() {
            if (this.savingStatus !== 'Saving...please wait') {
                this.savingStatus = 'Saving...please wait';
                if (!this.isOneOfTheseRoles(['parish-td', 'parish-missionary', 'alumni', 'lifelong'])) {
                    this.recurringType = 'Weekly';
                }
                let bibleStudyId = null;
                if (this.bibleStudy) {
                    bibleStudyId = this.bibleStudy.id;
                }
                const leaderIds = [];
                if (this.leaders.selected1) {
                    leaderIds.push(this.leaders.selected1.id);
                }
                if (this.leaders.selected2 && this.leaders.showSecond) {
                    leaderIds.push(this.leaders.selected2.id);
                }
                const bibleStudyData = {
                    id: bibleStudyId,
                    name: this.name,
                    leaders: leaderIds,
                    meeting_location: this.meetingLocation,
                };
                if (this.startDate) {
                    bibleStudyData.start_date = this.transformJSDateForPayload(this.startDate);
                }
                if (this.endDate) {
                    bibleStudyData.end_date = this.transformJSDateForPayload(this.endDate);
                }
                const bibleStudyScheduleData = {
                    recurring_type: this.recurringType,
                    day_of_week: this.dayOfWeek,
                    meeting_time: calculateTime(this.meetingHour, this.meetingMinute, this.meetingDayTime),
                };
                const participantIDs = [];
                this.selectedParticipants.forEach((participant) => participantIDs.push(participant.id));
                this.$emit('returnBSData', {
                    bible_study_data: bibleStudyData,
                    bible_study_schedule_data: bibleStudyScheduleData,
                    bible_study_participants_list: participantIDs,
                });
            }
        },
        // Participants
        handleRemoveFromSelected(participant) {
            this.unselectedParticipants.push(participant);
            this.selectedParticipants.splice(this.selectedParticipants.findIndex(
                (element) => element.id === participant.id
            ), 1);
        },
        queryEligibleParticipants(queryString, callback) {
            if (queryString.length === 0) callback(this.unselectedParticipants);
            else {
                const results = queryString
                    ? this.unselectedParticipants.filter(
                        this.createParticipantsFilter(queryString)
                    ) : this.unselectedParticipants;
                callback(results);
            }
        },
        createParticipantsFilter(queryString) {
            return (participant) => participant.name.toLowerCase().includes(queryString.toLowerCase());
        },
        handleSelectParticipant(participant) {
            this.selectedParticipants.push(participant);
            this.unselectedParticipants.splice(this.unselectedParticipants.findIndex(
                (element) => element.id === participant.id
            ), 1);
            this.queryBSPs = '';
        },
        // Leaders
        validateDeleteLeader(leaderPosition) {
            switch (leaderPosition) {
            case 1:
                this.leaders.delete = 1;
                if (this.leaders.selected1 && this.leaders.searchQuery1 !== '') {
                    this.leaders.validateDelete = true;
                } else {
                    this.removeLeader(1);
                }
                break;
            case 2:
                this.leaders.delete = 2;
                if (this.leaders.selected2 && this.leaders.searchQuery2 !== '') {
                    this.leaders.validateDelete = true;
                } else {
                    this.removeLeader(2);
                }
                break;
            default: break;
            }
        },
        addSecondLeader() {
            this.leaders.validateDelete = false;
            this.leaders.showSecond = true;
        },
        removeLeader(leaderPosition) {
            this.leaders.validateDelete = false;
            switch (leaderPosition) {
            case 1:
                if (this.leaders.selected2) {
                    this.leaders.searchQuery1 = this.leaders.searchQuery2;
                    this.leaders.selected1 = this.leaders.selected2;
                    this.leaders.searchQuery2 = '';
                    this.leaders.selected2 = null;
                    this.leaders.showSecond = false;
                } else {
                    this.leaders.searchQuery1 = '';
                    this.leaders.selected1 = null;
                }
                break;
            case 2:
                this.leaders.searchQuery2 = '';
                this.leaders.selected2 = null;
                this.leaders.showSecond = false;
                break;
            default: break;
            }
            this.leaders.delete = null;
        },
        checkEmpty() {
            if (this.leaders.searchQuery1 === '') {
                this.leaders.selected1 = null;
            }
            if (this.leaders.searchQuery2 === '') {
                this.leaders.selected2 = null;
            }
        },
        queryEligibleLeaders(queryString, callback) {
            if (queryString.length === 0) callback(this.eligibleLeaders);
            else {
                const results = queryString
                    ? this.eligibleLeaders.filter(this.createLeadersFilter(queryString)) : this.eligibleLeaders;
                callback(results);
            }
        },
        createLeadersFilter(queryString) {
            return (leader) => leader.name.toLowerCase().includes(queryString.toLowerCase());
        },
        handleSelectFirstLeader(leader) {
            this.leaders.selected1 = leader;
        },
        handleSelectSecondLeader(leader) {
            this.leaders.selected2 = leader;
        },
        handleClose() {
            if (this.bibleStudy) {
                this.updateBibleStudy();
            } else {
                this.selectedParticipants = [];
                this.name = '';
                this.leaders.searchQuery1 = '';
                this.leaders.searchQuery2 = '';
                this.leaders.selected1 = null;
                this.leaders.selected2 = null;
                this.leaders.validateDelete = false;
                this.leaders.hoverClass = false;
                this.leaders.showSecond = false;
                this.leaders.selected1 = null;
                this.dayOfWeek = '';
                this.meetingHour = '';
                this.meetingMinute = '';
                this.meetingDayTime = '';
                this.recurringType = '';
                this.meetingLocation = '';
                this.startDate = null;
            }
            this.validationErrors.nameError = '';
            this.validationErrors.leaderError = '';
            this.validationErrors.dayError = '';
            this.validationErrors.timeError = '';
            this.validationErrors.recurringTypeError = '';
            this.validationErrors.locationError = '';
            this.validationErrors.startDateError = '';
            this.savingStatus = 'Save';
        },
        updateBibleStudy() {
            if (this.bibleStudy) {
                this.name = this.bibleStudy.name;
                this.leaders.searchQuery1 = this.bibleStudy.leaders[0].name;
                this.leaders.selected1 = {
                    name: this.bibleStudy.leaders[0].name,
                    id: this.bibleStudy.leaders[0].person_id
                };
                if (this.bibleStudy.leaders.length > 1) {
                    this.leaders.showSecond = true;
                    this.leaders.searchQuery2 = this.bibleStudy.leaders[1].name;
                    this.leaders.selected2 = {
                        name: this.bibleStudy.leaders[1].name,
                        id: this.bibleStudy.leaders[1].person_id
                    };
                } else {
                    this.leaders.searchQuery2 = '';
                    this.leaders.selected2 = null;
                    this.leaders.showSecond = false;
                }
                this.dayOfWeek = this.bibleStudy.bible_study_schedule.day_of_week;
                this.meetingLocation = this.bibleStudy.meeting_location;
                this.meetingHour = sanitizeHour(this.bibleStudy.bible_study_schedule.meeting_time);
                this.meetingMinute = sanitizeMinute(this.bibleStudy.bible_study_schedule.meeting_time);
                this.meetingDayTime = sanitizeDayTime(this.bibleStudy.bible_study_schedule.meeting_time);
                this.recurringType = this.bibleStudy.recurring_type;
                if (this.bibleStudy.end_date) {
                    this.endDate = new Date(this.bibleStudy.end_date);
                } else {
                    this.endDate = null;
                }
            }
        },
    },
    created() {
        if (this.bibleStudy) {
            this.updateBibleStudy();
        }
    }
};
</script>
<style>
.el-input, .datepick {
    margin: 10px 0 10px 0;
}
.col-md-4{
    margin: auto;
}
.select-default.el-select.light-gray .el-input input {
    border-color: #DCDFE6 !important;
    border-width: 1px;
}
.select-default.el-select.light-gray .el-input:hover input:hover,
.select-default.el-select.light-gray .el-input:hover input, .select-default.el-select .el-input:hover .el-input__icon {
    border-color: #66615B !important;
}
.noError {
  border-left: 5px solid white;
}
.validationError {
  border-left: 5px solid red;
  background-color: lightpink;
  font-weight: bold;
}
.validationErrorText {
  color: red;
  font-weight: bold;
  margin: 3px 0 10px 0;
  text-align: center;
}
.datepicker input::placeholder {
    color: #C0C4CC;
}
.datepicker input {
    -webkit-appearance: none;
    color: #606266;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
    margin: 10px 0 10px 0;
}
.datepicker input:hover {
  border-color: #C0C4CC;
}
.add-shadowbox {
  text-align: center;
  width: 100%;
  margin: 4px 0 25px;
}
.add-shadowbox div {
  color: #606266;
  background-color: #ECECEC;
  border-radius: 5px;
  padding: 5px 0 5px 0;
}
.add-shadowbox div:hover {
  background-color: #DEDEDE;
  cursor: pointer;
}
.hoverClass {
  color: #409EFF;
}
</style>
